import { render, staticRenderFns } from "./GuideForNew.vue?vue&type=template&id=3d09b0a4&scoped=true"
import script from "./GuideForNew.vue?vue&type=script&lang=js"
export * from "./GuideForNew.vue?vue&type=script&lang=js"
import style0 from "./GuideForNew.vue?vue&type=style&index=0&id=3d09b0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d09b0a4",
  null
  
)

export default component.exports